import React from 'react'

const GppMaybeIcon = ({ className, size = 20, currentColor = '#EA580C' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={currentColor}>
      <mask id="mask0_6943_4057" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6943_4057)">
        <path d="M9.99967 13.3337C10.2358 13.3337 10.4337 13.2538 10.5934 13.0941C10.7531 12.9344 10.833 12.7364 10.833 12.5003C10.833 12.2642 10.7531 12.0663 10.5934 11.9066C10.4337 11.7469 10.2358 11.667 9.99967 11.667C9.76356 11.667 9.56565 11.7469 9.40592 11.9066C9.2462 12.0663 9.16634 12.2642 9.16634 12.5003C9.16634 12.7364 9.2462 12.9344 9.40592 13.0941C9.56565 13.2538 9.76356 13.3337 9.99967 13.3337ZM9.16634 10.0003H10.833V5.83366H9.16634V10.0003ZM9.99967 18.3337C8.06912 17.8475 6.47537 16.7399 5.21842 15.0107C3.96148 13.2816 3.33301 11.3614 3.33301 9.25033V4.16699L9.99967 1.66699L16.6663 4.16699V9.25033C16.6663 11.3614 16.0379 13.2816 14.7809 15.0107C13.524 16.7399 11.9302 17.8475 9.99967 18.3337Z" fill={currentColor} />
      </g>
    </svg >
  )
}

export default GppMaybeIcon
